export default __webpack_public_path__ + "static/media/img1.8b800205.jpg";